import type { AxiosRequestConfig, AxiosResponse } from 'axios';

/** Request config of a call whose body must not reach an error report, not even redacted. */
export interface ReportableRequestConfig extends AxiosRequestConfig {
  omitBodyInReports?: boolean;
}

/** The POST of an axios instance, as `axiosInstance.post`. */
export type AxiosPost = (
  url: string,
  data?: Record<string, unknown>,
  config?: AxiosRequestConfig,
) => Promise<AxiosResponse>;

/**
 * POST that is never re-sent and whose body stays out of error reports. A
 * retry after a lost answer can charge a payment twice, so the caller
 * reconciles an unknown outcome instead; the body carries the encrypted card.
 */
export const makePostOnce =
  (post: AxiosPost): AxiosPost =>
  (url, data, config) => {
    const once: ReportableRequestConfig = {
      ...config,
      omitBodyInReports: true,
    };
    return post(url, data, once);
  };

/** The body of a failed request as an error report may carry it; `undefined` for a `postOnce` call. */
export const reportableBody = (config: ReportableRequestConfig): unknown =>
  config.omitBodyInReports ? undefined : config.data;
